export interface OpcaoFiltravel {
    label: string;
    /** Grupo da opcao (ex.: a categoria-pai de uma subcategoria). */
    group?: string;
}

export function normalizar(str: string): string {
    return str
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase();
}

/**
 * Opcoes que casam com o que foi digitado.
 *
 * Sem grupos: quem comeca com o texto vem antes de quem so o contem.
 * Com grupos (MAN-130): a ordem original e mantida, para os grupos continuarem
 * na ordem do plano de contas, e o texto tambem casa com o nome do grupo
 * (digitar "custos" mostra todas as categorias de Custos).
 */
export function filtrarOpcoes<T extends OpcaoFiltravel>(options: T[], query: string): T[] {
    if (!query.trim()) return options;
    const q = normalizar(query.trim());

    if (options.some((o) => o.group)) {
        return options.filter(
            (o) => normalizar(o.label).includes(q) || (!!o.group && normalizar(o.group).includes(q)),
        );
    }

    const startsWith: T[] = [];
    const includes: T[] = [];
    for (const opt of options) {
        const label = normalizar(opt.label);
        if (label.startsWith(q)) {
            startsWith.push(opt);
        } else if (label.includes(q)) {
            includes.push(opt);
        }
    }
    return [...startsWith, ...includes];
}

/** A opcao abre um grupo novo na lista (o cabecalho do grupo vem antes dela). */
export function abreGrupo(options: OpcaoFiltravel[], idx: number): boolean {
    const grupo = options[idx]?.group;
    return !!grupo && grupo !== options[idx - 1]?.group;
}
